/** localStorage record for a Meta Purchase that must fire once on the confirmation page. */
export const META_PURCHASE_STORAGE_PREFIX = 'metaPurchase:';

export const META_PURCHASE_RECORD = {
  PENDING: 'pending',
  FIRED: 'fired',
};

/** Hotel booking statuses that mean the stay is confirmed and paid. */
export const HOTEL_META_PURCHASE_CONFIRMED_STATUSES = Object.freeze([
  'confirmed',
  'tbo_confirmed',
]);

/**
 * Hotel booking statuses that are not a purchase.
 * A pending key for these is dropped so a later reopen cannot send Purchase.
 */
export const HOTEL_META_PURCHASE_SKIP_STATUSES = Object.freeze([
  'cancelled',
  'cancel_pending',
  'failed',
  'booking_failed',
]);
